import { useListFunctionRole, useListMenu } from "hooks";
import jwt_decode from "jwt-decode";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Collapse } from "reactstrap";
import { AUTH_TOKEN } from "store/auth/login/actionTypes";
import ConfigMenu from "./ConfigMenu";

const Navbar = props => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { t, i18n } = useTranslation(["menuManagement"]);

  const { leftMenu } = useSelector(state => state.Layout);

  const [listMenuConfig, setListMenuConfig] = useState([]);
  const [isMenuLoaded, setIsMenuLoaded] = useState(false);
  const [isShowDashboard, setIsShowDashboard] = useState(true);

  // List Function Role
  const onSuccessListFunctionRole = data => {};
  const { refetch: listFunctionRole } = useListFunctionRole(
    { params: {}, isEnabled: true },
    onSuccessListFunctionRole
  );

  // List Menu
  const onSuccessMenuList = data => {
    if (data.items && data.items.length > 0) {
      setListMenuConfig(data.items);
    }
  };
  const { refetch: listMenu, remove: resetMenu } =
    useListMenu(onSuccessMenuList);

  // Load Menu Every Time Change "Link" Or Change "language"
  useEffect(() => {
    listMenu();
    return () => {
      resetMenu();
      setListMenuConfig([]);
      setIsMenuLoaded(false);
    };
  }, [dispatch, t, location.pathname]);

  // Find Active Menu
  useEffect(() => {
    const pathName = location.pathname;
    let matchingMenuItem = null;
    if (pathName && !isMenuLoaded) {
      const ul = document.getElementById("navigation");
      const items = ul.getElementsByTagName("a");
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }

        const dataHref = items[i].attributes.datahref;
        if (dataHref && dataHref.value) {
          const arrHref = dataHref.value.split("___");
          if (arrHref.some(x => x === pathName)) {
            matchingMenuItem = items[i];
            break;
          }
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }

      setIsMenuLoaded(true);
    }
  }, [isMenuLoaded, listMenuConfig.length, location.pathname]);

  useEffect(() => {
    const token = localStorage.getItem(AUTH_TOKEN);
    if (token) {
      const info = jwt_decode(token);
      if (info["auth"]) {
        if (String(info["auth"]).includes("GS_SALE")) {
          setIsShowDashboard(false);
        }
      }
    }
  }, []);

  function activateParentDropdown(item) {
    const navActive = document.querySelector("#topnav-menu-content li.active");
    if (!!navActive) {
      navActive.classList.remove("active");
      navActive.firstChild.classList.remove("active");
      if (navActive.children.length > 1) {
        navActive.lastChild.classList.remove("active");
        if (navActive.lastChild.children.length > 0) {
          const childActive = document.querySelector(
            "#topnav-menu-content div a.active"
          );
          childActive.classList.remove("active");
        }
      }
    }
    item.classList.add("active");
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add("active"); // li
      const parent2 = parent.parentElement;
      parent2.classList.add("active"); // li
      const parent3 = parent2.parentElement;
      if (parent3) {
        parent3.classList.add("active"); // li
        const parent4 = parent3.parentElement;
        if (parent4) {
          parent4.classList.add("active"); // li
          const parent5 = parent4.parentElement;
          if (parent5) {
            parent5.classList.add("active"); // li
            const parent6 = parent5.parentElement;
            if (parent6) {
              parent6.classList.add("active"); // li
            }
          }
        }
      }
    }
    return false;
  }

  return (
    <React.Fragment>
      <div className="topnav">
        <div className="container-fluid">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav">
                <ConfigMenu
                  menuOpen={props.menuOpen}
                  menuArr={listMenuConfig}
                />
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  );
};

Navbar.propTypes = {
  menuOpen: PropTypes.any,
};

export default Navbar;
